var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagFr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-fr_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#flag-fr_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F50100",
  d: "M22 0h10v24H22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E42A5",
  d: "M0 0h12v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7FCFF",
  d: "M10 0h12v24H10z"
}))));
export default SvgFlagFr;